import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon2: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M10 0C15.5228 0 20 4.47727 20 10C20 15.5227 15.5228 20 10 20C4.47718 20 0 15.5227 0 10C0 4.47727 4.47718 0 10 0ZM10 0.909091C4.97927 0.909091 0.909091 4.97909 0.909091 10C0.909091 15.0209 4.97927 19.0909 10 19.0909C15.0207 19.0909 19.0909 15.0209 19.0909 10C19.0909 4.97909 15.0207 0.909091 10 0.909091ZM14.5455 5.45455C14.7965 5.45455 15 5.65818 15 5.90909V14.0909C15 14.3418 14.7965 14.5455 14.5455 14.5455C14.2945 14.5455 14.0909 14.3418 14.0909 14.0909V10.4545H10.4545V14.0909C10.4545 14.3418 10.251 14.5455 10 14.5455C9.749 14.5455 9.54545 14.3418 9.54545 14.0909V10.4545H5.90909V14.0909C5.90909 14.3418 5.70555 14.5455 5.45455 14.5455C5.20355 14.5455 5 14.3418 5 14.0909V5.90909C5 5.65818 5.20355 5.45455 5.45455 5.45455C5.70555 5.45455 5.90909 5.65818 5.90909 5.90909V9.54545H9.54545V5.90909C9.54545 5.65818 9.749 5.45455 10 5.45455C10.251 5.45455 10.4545 5.65818 10.4545 5.90909V9.54545H14.0909V5.90909C14.0909 5.65818 14.2945 5.45455 14.5455 5.45455Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
